import { OrderResultSuccess } from '@spa/store/modules/orderConfirm/types'

/**
 * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=1228647551205989991-NC&hl=ja&client_type=gtm#purchase
 */
export interface PurchaseEvent {
  event: 'purchase'
  ecommerce: {
    currency: 'JPY',
    value: number,
    transaction_id: string,
    shipping: number,
    items: PurchaseItem[]
  }
}

export interface PurchaseItem {
  item_id: string,
  item_name: string,
  item_variant: string,
  price: number,
  quantity: number,
}

const createFromOrderResult = (orderResult: OrderResultSuccess): PurchaseEvent => {
  const subtotal = orderResult.commerceSalesOrder.subtotalPrice
  const shipping = orderResult.commerceSalesOrder.shipping
  const items = orderResult.order.cartItems.map(cartItem => ({
    item_name: cartItem.name,
    item_id: cartItem.skuId,
    item_variant: cartItem.color || '',
    price: cartItem.unitPrice,
    quantity: cartItem.unitCount,
  }))

  return {
    event: 'purchase',
    ecommerce: {
      currency: 'JPY',
      value: subtotal,
      transaction_id: orderResult.commerceSalesOrder.compressedShortId,
      shipping,
      items,
    },
  }
}

export const purchaseEventFactory = {
  createFromOrderResult,
} as const
